import React, { useState, type ReactNode } from "react";
import { SelectInput, type SelectOption } from "@SeemplicityDev/shared";
import AddWidgetDefinitionAction from "./AddWidgetDefinitionAction";
import "./LaunchPublicActions.scss";

const ADD_WIDGET_DEFINITION = "ADD_WIDGET_DEFINITION";

interface ActionOption {
  label: string;
  value: string;
  component: ReactNode;
}

const LaunchPublicAction: React.FC = () => {
  const [currentAction, setCurrentAction] = useState(ADD_WIDGET_DEFINITION);

  const actions: ActionOption[] = [
    {
      label: "Add Widget Definition",
      value: ADD_WIDGET_DEFINITION,
      component: <AddWidgetDefinitionAction />,
    },
  ];

  return (
    <div className={"public-action-launcher-wrapper"}>
      <div className={"action-launch-container"}>
        <SelectInput
          data-testid={"action"}
          value={actions.find((action) => action.value === currentAction)}
          labelTop
          onChange={(selectedValue: SelectOption) =>
            setCurrentAction(selectedValue.value)
          }
          placeholder={"Select an action to launch"}
          label={"Action"}
          options={actions}
          required
        />
        <div className="action-form">
          {actions.find((action) => action.value === currentAction)?.component}
        </div>
      </div>
    </div>
  );
};
export default LaunchPublicAction;
